import { FC } from 'react';
import Grid from '@mui/material/Grid';
import contactImg from '../../media/contact.png';
import { Button, Paper, Typography, SvgIcon, Box } from '@mui/material';
import useTranslations from '../global/translation/hooks/translation';
import { LocationOn, Phone } from '@mui/icons-material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import { useTheme } from '@mui/material/styles';
import { useThemeContext } from '../global/ThemeContext';

const Contact: FC = () => {
  const { currentLanguage, translations } = useTranslations();
  const theme = useTheme();
  const { darkMode } = useThemeContext();

  const headlightStyle = {
    position: 'absolute',
    bottom: '-8%', // Adjust Y position for the headlight
    left: '20%', // Adjust X position for the headlight
    width: '35%', // Adjust size of the circle
    height: '35%', // Adjust size of the circle (make equal to width for circle)
    // Use a radial gradient for a softer glow effect
    background: 'radial-gradient(circle, rgba(255, 255, 150, 0.6) 0%, rgba(255, 255, 0, 0) 70%)',
    borderRadius: '50%', // Make it circular
    pointerEvents: 'none',
    opacity: darkMode ? 1 : 0, // Control visibility with opacity
    transition: 'opacity 0.5s ease-in-out', // Add transition for opacity
  };

  return (
    <Grid
      my={16}
      py={2}
      container
      justifyContent="center"
      alignItems="center"
      pb={6}
      sx={{
        bgcolor: darkMode ? '#181818' : '#F9F9F9',
        borderTop: `1px solid ${darkMode ? '#232323' : theme.palette.divider}`,
      }}
    >
      <Grid item xs={12} m={2}>
        <Typography variant="h4" fontWeight={300} sx={{ color: darkMode ? '#fff' : '#232323' }} textAlign="center">
          {translations.menuItems.contact[currentLanguage]}
        </Typography>
      </Grid>
      <Grid item xs={12} md={6}>
        <Box sx={{ position: 'relative', paddingTop: '65%', margin: '16px' }}>
          {' '}
          {/* Changed div to Box */}
          <img
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'scale-down' }}
            src={contactImg} // Reverted to always use contactImg
            alt="Contact location"
          />
          {/* Add the circular headlight overlay */}
          <Box sx={headlightStyle} />
        </Box>
      </Grid>
      <Grid item xs={12} md={6}>
        <Paper elevation={12} sx={{ p: 2, m: 2, background: darkMode ? '#565656' : '#fff' }}>
          <Button
            variant="text"
            fullWidth
            onClick={() => {
              window.open(
                'https://www.google.com/maps/dir//Urban+Equestrian,+Koszary/@51.1245855,21.1794487,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x47186ddde34b675b:0xed82cb2b23b6e247!2m2!1d21.2494807!2d51.1245984'
              );
            }}
            startIcon={<LocationOn sx={{ color: darkMode ? '#fff' : '#232323' }} />}
            sx={{ color: darkMode ? '#fff' : '#232323', justifyContent: 'left', textTransform: 'none', fontWeight: 300 }}
          >
            Koszary 8b, 27-100, Iłza
          </Button>
          <Button
            variant="text"
            fullWidth
            onClick={() => window.open('tel:729883891', '_self')}
            startIcon={<Phone sx={{ color: darkMode ? '#fff' : '#232323' }} />}
            sx={{ color: darkMode ? '#fff' : '#232323', my: 1, justifyContent: 'left', textTransform: 'none', fontWeight: 300 }}
          >
            (+48) 729 883 891
          </Button>
          <Button
            variant="text"
            fullWidth
            onClick={() => window.open('https://www.facebook.com/profile.php?id=100063462341954')}
            startIcon={<FacebookIcon sx={{ color: darkMode ? '#fff' : '#232323' }} />}
            sx={{ color: darkMode ? '#fff' : '#232323', textTransform: 'none', fontWeight: 300, my: 1, justifyContent: 'left' }}
          >
            Facebook
          </Button>
          <Button
            variant="text"
            fullWidth
            onClick={() => window.open('https://www.instagram.com/urbanequestrian_pl/?locale=pl&hl=am-et')}
            startIcon={<InstagramIcon sx={{ color: darkMode ? '#fff' : '#232323' }} />}
            sx={{ color: darkMode ? '#fff' : '#232323', textTransform: 'none', fontWeight: 300, my: 1, justifyContent: 'left' }}
          >
            Instagram
          </Button>
          <Button
            variant="text"
            fullWidth
            onClick={() => window.open('https://www.tiktok.com/@urban.equestrian')}
            startIcon={
              <SvgIcon>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill={darkMode ? '#fff' : '#232323'}>
                  <path d="M41.5 15.5c-3.2 0-5.8-2.6-5.8-5.8V6.5c0-0.6-0.4-1-1-1h-4.2c-0.6 0-1 0.4-1 1v25.2c0 3.2-2.6 5.8-5.8 5.8s-5.8-2.6-5.8-5.8 2.6-5.8 5.8-5.8c0.6 0 1-0.4 1-1v-4.2c0-0.6-0.4-1-1-1-6.1 0-11 4.9-11 11s4.9 11 11 11 11-4.9 11-11v-9.6c1.7 1 3.7 1.6 5.8 1.6 0.6 0 1-0.4 1-1v-4.2c0-0.6-0.4-1-1-1z" />
                </svg>
              </SvgIcon>
            }
            sx={{ color: darkMode ? '#fff' : '#232323', textTransform: 'none', fontWeight: 300, my: 1, justifyContent: 'left' }}
          >
            TikTok
          </Button>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default Contact;
